<script lang="ts">
import type { ComputedRef, VNodeChild } from 'vue';
import { createContext } from 'reka-ui';

export interface PageHeaderContext {
	registerHeaderSlot: (slotContent: ComputedRef<VNodeChild>) => void;
}

export const [injectPageHeaderContext, providePageHeaderContext] = createContext<PageHeaderContext>('PageShellHeader');
</script>

<script setup lang="ts">
import { PageSlotProvider } from '#layers/chrome/components/page-slot-provider';
import ProjectChromePanelProvider from '#layers/chrome/components/ProjectChromePanelProvider.vue';
</script>

<template>
	<PageSlotProvider>
		<ProjectChromeHeader class="shrink-0">
			<slot name="header-title" />
		</ProjectChromeHeader>

		<div
			class="flex flex-1 flex-col overflow-hidden rounded-sm border bg-default min-block-0"
		>
			<ProjectChromePanelProvider>
				<div class="@container relative flex-1 overflow-x-hidden overflow-y-auto">
					<slot />
				</div>
			</ProjectChromePanelProvider>
		</div>
		<UploadProgress />
	</PageSlotProvider>
</template>
